var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationBell = function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Notification_Bell_svg__a)",
    fill: "#344054"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5c1.1 0 2-.4 2-1.5h-4c0 1.1.9 1.5 2 1.5ZM6 16l-2 2v1h16v-1l-2-2h-2v1H8v-1H6ZM18 11c0-3.07-1.63-5.64-4.5-6.32-1.412-.335-2.667-.107-3 0C7.64 5.36 6 7.92 6 11v4h2v-4c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v4h2v-4ZM13.5 4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.34c.333-.107 1.588-.335 3 0V4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Notification_Bell_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNotificationBell;